// Selected (pinned) items first, preserving relative order within each group.
export function orderSelectedFirst(items, pinnedIds, { enabled = false } = {}) {
  if (!enabled) return items;
  const pinned = new Set(pinnedIds);
  const selected = [];
  const rest = [];
  items.forEach((item) => (pinned.has(item?.id ?? item?.value) ? selected : rest).push(item));
  return [...selected, ...rest];
}
